export enum ActionConfigPlacement {
  Start = 'start',
  End = 'end'
}
